import { render } from "./canceled_term.vue?vue&type=template&id=2fdc4574"
import script from "./canceled_term.vue?vue&type=script&lang=js"
export * from "./canceled_term.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__